<template>
	<component
		:is="to ? 'router-link' : 'li'"
		:to="to || undefined"
		class="list-group-item schedule-tile"
		:class="{'list-group-item-action': to || action}">
		<div class="schedule-tile-icon">
			<i class="fa" :class="icon"></i>
		</div>
		<div class="schedule-tile-body">
			<div class="schedule-tile-top">
				<div class="schedule-tile-title">{{ title }}</div>
				<div v-if="rightText" class="schedule-tile-time">{{ rightText }}</div>
			</div>
			<div v-if="meta" class="schedule-tile-line">{{ meta }}</div>
			<div v-if="customerName" class="schedule-tile-line">{{ customerName }}</div>
			<div v-if="address" class="schedule-tile-line">{{ address }}</div>
		</div>
	</component>
</template>

<script type="text/javascript">
export default {
	name: "ListJobTile",
	props: ["icon", "title", "rightText", "meta", "customerName", "address", "to", "action"]
}
</script>

<style scoped>
.schedule-tile {
	display: flex;
	align-items: flex-start;
	color: var(--background-menus);
	text-decoration: none;
}

.schedule-tile:hover {
	color: var(--background-menus);
	text-decoration: none;
}

.schedule-tile-icon {
	flex-shrink: 0;
	width: 48px;
	height: 48px;
	border-radius: 50%;
	background-color: var(--brand-primary-color);
	color: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 1rem;
	font-size: 1.25rem;
}

.schedule-tile-body {
	flex-grow: 1;
	min-width: 0;
}

.schedule-tile-top {
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
}

.schedule-tile-title,
.schedule-tile-time {
	font-weight: bold;
}

.schedule-tile-time {
	margin-left: 1rem;
	text-align: right;
	max-width: 55%;
	white-space: normal;
}

.schedule-tile-line {
	line-height: 1.4;
}
</style>
